import instance from '@apis/instance';
import { GetGiftItemsParams, GiftItemRow } from '@models/gift';

class GiftItemApi {
    static getGiftItems(params: GetGiftItemsParams): Promise<GiftItemRow[]> {
        return instance.get('/gift-items', { params });
    }

    static getGiftItem(id: string): Promise<GiftItemRow> {
        return instance.get(`/gift-item/${id}`);
    }
}

export default GiftItemApi;
